import { SavingState } from '@common/Common';
import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import SaveButton from '@common/Components/SaveButton.vue';
import { ICommandBase } from '@Quest/cqrs';
import { UpdatePnlCommandV1 } from '@Quest/Pnls/Domain/commands-core';
import PnlsCommands from '@Quest/Pnls/Domain/commands-vue-component';
import PnlsQueries from '@Quest/Pnls/Domain/queries-vue-component';
import { CorporatePnlTemplateReadModel } from '@Quest/Pnls/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({ components: { CorporateNavigation, SaveButton } })
export default class PnlEditPage extends mixins(PnlsCommands, PnlsQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: CorporatePnlTemplateReadModel | null = null;
    savingState: SavingState = SavingState.Pending;


    handleUpdatePnlCommand()
    {
        if (this.rm)
        {
            this.savingState = SavingState.InProgress;
            this.invokeUpdatePnlCommandV1(this.workspaceId, this.strategyId, this.rm.Id, this.rm.Name, this.rm.StartYear, this.rm.StartMonth, this.rm.Columns);
        }
    }

    mounted()
    {
        document.title = "Edit P&L | TransparentChoice";
        this.runCorporatePnlTemplateByIdQueryV1(this.workspaceId, this.strategyId, this.$route.params.pnlId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "CorporatePnlTemplateReadModel")
        {
            this.rm = model as CorporatePnlTemplateReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdatePnlCommandV1.matchType(cmd))
        {
            this.savingState = SavingState.Pending;
            alert('Saved');
        }
    }
}